<template>
<div>
    <div class="columns">
        <div class="column is-full has-text-centered" style="margin-top: 130px;">
            <p style="font-weight:600;color:#868e96;">Page not found.</p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    //
}
</script>
